import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense, lazy, useEffect, useState } from "react";

/**
 * See: https://tanstack.com/query/v4/docs/react/devtools#devtools-in-production
 */
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/lib/index.prod.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

export const CacheDevTools = () => {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    // @ts-expect-error - add helper to window to toggle react-query's debugger
    window.toggleCacheTools = () => setShowDevtools((previous) => !previous);
  }, []);

  return (
    <>
      <ReactQueryDevtools initialIsOpen={false} />
      {showDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </Suspense>
      )}
    </>
  );
};
